(function (root) {
  const metadata = (item) => {
    try { const value = JSON.parse(item.properties?.__kaching_bundles || '{}'); return value && typeof value === 'object' && !Array.isArray(value) ? value : {}; } catch { return {}; }
  };
  function groups(items) {
    const result = new Map();
    for (const item of items) {
      const meta = metadata(item);
      const plan = item.selling_plan_allocation?.selling_plan;
      const id = meta.id ? `${meta.deal}:${meta.id}:${plan?.id || ''}` : item.key;
      if (!result.has(id)) result.set(id, { id, items: [], title: item.product_title, plan, quantity: 0, total: 0, original: 0 });
      const group = result.get(id);
      group.items.push(item);
      group.quantity += item.quantity;
      group.total += item.final_line_price;
      group.original += item.original_line_price;
    }
    return Array.from(result.values()).map(group => {
      const components = new Map();
      group.items.forEach((item, index) => {
        const identity = JSON.stringify([item.variant_id || item.id, Object.entries(item.properties || {}).sort(([a], [b]) => a.localeCompare(b))]);
        if (!components.has(identity)) components.set(identity, { index, base: Number(item.properties?._natunora_line_size), quantity: 0 });
        components.get(identity).quantity += item.quantity;
      });
      const parts = Array.from(components.values());
      const counts = parts.map(part => part.quantity / part.base);
      const known = parts.every(part => Number.isInteger(part.base) && part.base > 0) && counts.every(count => Number.isInteger(count) && count === counts[0]);
      const plain = parts.length === 1 && !metadata(group.items[0]).deal;
      group.editable = known || plain;
      group.packs = known ? counts[0] : plain ? group.quantity : 1;
      group.sizes = group.items.map((item, index) => known ? (parts.find(part => part.index === index)?.base || 0) : plain && index === 0 ? 1 : 0);
      group.packTitle = group.items[0].properties?._natunora_pack_title || group.items[0].variant_title || '';
      group.isExtra = group.items.some(item => item.properties?._natunora_extra === 'true');
      group.imageCount = group.isExtra ? 1 : known ? parts.reduce((sum, part) => sum + part.base, 0)
        : /3\s*\+\s*2/.test(group.packTitle) ? 5 : /2\s*\+\s*1/.test(group.packTitle) ? 3 : 1;
      return group;
    });
  }
  function updates(group, packs) {
    if (!Number.isInteger(packs) || packs < 0 || (packs > 0 && !group.editable)) throw new Error('Ungültige Paketmenge.');
    return Object.fromEntries(group.items.map((item, index) => [item.key, packs === 0 ? 0 : group.sizes[index] * packs]));
  }
  function bundleItems(items, title) {
    if (!items?.length || items.some(item => !item.id || !Number.isInteger(item.quantity) || item.quantity < 1)) throw new Error('Bitte wähle ein verfügbares Paket.');
    return items.map(item => ({ ...item, properties: { ...item.properties, _natunora_line_size: String(item.quantity), _natunora_pack_title: title } }));
  }
  function oneTimeItems(items) {
    return items.map(({ selling_plan, ...item }) => {
      const properties = { ...item.properties };
      if (properties.__kaching_bundles) {
        const metadata = JSON.parse(properties.__kaching_bundles);
        delete metadata.sellingPlan;
        properties.__kaching_bundles = JSON.stringify(metadata);
      }
      return { ...item, properties };
    });
  }
  function giftPlan(items, gifts, productId) {
    const eligible = items.filter(item => String(item.product_id) === String(productId) && item.properties?._natunora_offer_group === 'b');
    const hasSubscription = eligible.some(item => item.selling_plan_allocation?.selling_plan?.id);
    return gifts.map(gift => {
      const qualifying = eligible.filter(item => Number(item.properties?._natunora_gift_tier) >= gift.tier);
      const count = qualifying.reduce((sum, item) => sum + item.quantity, 0);
      const desired = hasSubscription && count >= gift.minimum ? 1 : 0;
      const lines = items.filter(item => String(item.variant_id || item.id) === String(gift.variantId));
      return { ...gift, desired, lines };
    });
  }
  function giftsValid(plan) {
    return plan.every(gift => gift.lines.reduce((sum, item) => sum + item.quantity, 0) === gift.desired && gift.lines.every(item => item.final_line_price === 0 && !item.selling_plan_allocation));
  }
  const api = { metadata, groups, updates, bundleItems, oneTimeItems, giftPlan, giftsValid };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  else root.NatunoraCartModel = api;
})(typeof window === 'undefined' ? globalThis : window);
